import { useState } from 'react';
import {Box,Flex,Select,Text,Grid,} from '@chakra-ui/react';
import MyDiv from './editWorkCard.style';
import { CustomButton } from '../../../../components';

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const hours = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));
const minutes = ['00', '15', '30', '45'];
const periods = ['AM', 'PM'];

const EditWorkCard = () => {
  const [schedule, setSchedule] = useState(() =>
    days.map((day) => ({
      day,
      status: 'Working',
      inTime: { hh: '', mm: '', period: 'AM' },
      outTime: { hh: '', mm: '', period: 'PM' },
    }))
  );

  const handleStatusChange = (index: number, value: string) => {
    const newSchedule = [...schedule];
    newSchedule[index].status = value;
    setSchedule(newSchedule);
  };

  const handleTimeChange = (
    index: number,
    type: 'inTime' | 'outTime',
    field: 'hh' | 'mm' | 'period',
    value: string
  ) => {
    const newSchedule = [...schedule];
    newSchedule[index][type][field] = value;
    setSchedule(newSchedule);
  };

  return (
    <MyDiv>
      <Box>
        <Box className="page_heading" w="100%" textAlign="center">
          <Text className="font-poppins text_semibold text_xl font_dark">Edit Work Week</Text>
        </Box>
        <Grid className="grid_header">
          <Text className='font-poppins font_dark text_md text_medium '>Day</Text>
          <Text className='font-poppins font_dark text_md text_medium '>Working</Text>
          <Text className='font-poppins font_dark text_md text_medium '>In Time</Text>
          <Text className='font-poppins font_dark text_md text_medium '>Out Time</Text>
        </Grid>

        {schedule.map((entry, index) => (
          <Grid key={entry.day} className="row">
            <Text className='font-poppins text_md text_regular'>{entry.day}</Text>
            <Select value={entry.status} onChange={(e) => handleStatusChange(index, e.target.value)} size="sm">
              <option value="Working" >Working</option>
              <option value="Not Working">Not Working</option>
            </Select>

            {entry.status === 'Working' ? (
              <>
                <Flex className="in_time">
                  <Select placeholder="HH" value={entry.inTime.hh} onChange={(e) => handleTimeChange(index, 'inTime', 'hh', e.target.value)} size="sm">
                    {hours.map((h) => (
                      <option key={h} value={h}>{h}</option>
                    ))}
                  </Select>
                  <Select placeholder="MM" value={entry.inTime.mm} onChange={(e) => handleTimeChange(index, 'inTime', 'mm', e.target.value)} size="sm">
                    {minutes.map((m) => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </Select>
                  <Select value={entry.inTime.period} onChange={(e) => handleTimeChange(index, 'inTime', 'period', e.target.value)} size="sm">
                    {periods.map((p) => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </Select>
                </Flex>

                <Flex className="out_time">
                  <Select placeholder="HH" value={entry.outTime.hh} onChange={(e) => handleTimeChange(index, 'outTime', 'hh', e.target.value)} size="sm">
                    {hours.map((h) => (
                      <option key={h} value={h}>{h}</option>
                    ))}
                  </Select>
                  <Select placeholder="MM" value={entry.outTime.mm} onChange={(e) => handleTimeChange(index, 'outTime', 'mm', e.target.value)} size="sm">
                    {minutes.map((m) => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </Select>
                  <Select value={entry.outTime.period} onChange={(e) => handleTimeChange(index, 'outTime', 'period', e.target.value)} size="sm">
                    {periods.map((p) => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </Select>
                </Flex>
              </>
            ) : (
              <>
                <Text className="placeholder-text">-</Text>
                <Text className="placeholder-text">-</Text>
              </>
            )}
          </Grid>
        ))}
        <Flex className="update_btn">
          <CustomButton title="Update Work Week" className='text_medium font-poppins text_md btn btn_theme'/>
        </Flex>
      </Box>
    </MyDiv>
  );
};

export default EditWorkCard;
